module.exports = __webpack_public_path__ + "img/meetsanta5.8168004c.jpg";